// Авто-резолвер hex по назві кольору — ДЗЕРКАЛО client/src/shared/lib/colorPresetHex.js.
// Використовується в адмінці лише для ПРЕВ'Ю (який колір вітрина покаже автоматично,
// якщо адмін не задав свій hex). Тримати синхронним з клієнтським файлом.
const RAW_HEX_BY_VALUE = {
  black: "#1a1a1a",
  red: "#e53935",
  white: "#ffffff",
  beige: "#d4c4b0",
  silver: "#c4c9ce",
  transparent: "#e8eef5",
  pink: "#ff99d6",
  shokolad: "#5d4037",
  "nizhno-blakytnyy": "#b7dff5",
  "temno-syniy": "#1f3f75",
  marsala: "#8e445a",
  pisochnyy: "#d8be8a",
  zelenyy: "#2e7d32",
  grey: "#9e9e9e",
  "temno-bezhevyy": "#b79d7f",
  lilovyy: "#b39ddb",
  molochnyy: "#f4efe6",
  "bilo-siryy": "#d9dde2",
  holubyy: "#64b5f6",
  "burhundi-piton": "#7b2d3a",
  bordovyy: "#7a1f2b",
  vyshnevyy: "#a5273f",
  korychnevyy: "#6d4c41",
  "svitlo-rozhevyy": "#f8bbd0",
  "sriblo-matovyy": "#b8bec6",
  persyk: "#ffccac",
  "rozhevyy-matovyy": "#d98ca8",
  smarahdovyy: "#0f8b6f",
  "lakovyy-chornyy": "#111111",
  "svitlo-blakytnyy": "#c7e7ff",
  bordo: "#7b2230",
  mokko: "#8d6e63",
  "chornyy-chervoni-vstavky": "#472126",
  "holubo-siryy": "#8ea8bf",
  elektryk: "#2962ff",
  karamel: "#c68a4b",
  "temno-shokoladnyy": "#4a2c2a",
  malynovyy: "#d81b60",
  "svitlo-bezhevyy": "#eadcc9",
  "sneyk-zelenye": "#7a8f45",
  oranzhevyy: "#fb8c00",
  lymonnyy: "#f6e65b",
  "nizhno-rozhevyy": "#f6c1d0",
  "rozhevyy-pyton": "#d88ea6",
  "shokoladnyy-pyton": "#6a4a3c",
  "chornyy-pyton": "#2f2f34",
  "bezhevo-rozhevi": "#d9b6ad",
  "nezhno-holubye": "#b9e1f2",
  "lymonno-zhovtyy": "#efe65a",
  zhovtyy: "#fbc02d",
  gold: "#d4af37",
  "prozoryy-u-rozhevomu-konverti": "#f3dce6",
  byryuza: "#33b8b0",
  zmiya: "#8a816f",
  siiryy: "#9e9e9e",
  burhundi: "#7a263a",
  sriblo: "#c4c9ce",
  syniy: "#1565c0",
  blakytnyy: "#42a5f5",
  navy: "#1e3a5f",
  brown: "#6d4c41",
  green: "#2e7d32",
  blue: "#1565c0",
  yellow: "#fbc02d",
  orange: "#fb8c00",
  purple: "#7b1fa2",
  gray: "#9e9e9e",
};

const CYRILLIC_TO_LATIN = {
  а: "a", б: "b", в: "v", г: "h", ґ: "g", д: "d", е: "e", ё: "e", є: "ye",
  ж: "zh", з: "z", и: "y", і: "i", ї: "yi", й: "y", к: "k", л: "l", м: "m",
  н: "n", о: "o", п: "p", р: "r", с: "s", т: "t", у: "u", ф: "f", х: "kh",
  ц: "ts", ч: "ch", ш: "sh", щ: "shch", ъ: "", ы: "y", ь: "", э: "e",
  ю: "yu", я: "ya",
};

function transliterateCyrillic(value) {
  return String(value ?? "")
    .split("")
    .map((char) => CYRILLIC_TO_LATIN[char] ?? char)
    .join("");
}

function normalizeColorKey(value) {
  return transliterateCyrillic(String(value ?? "").trim().toLowerCase())
    .replace(/[()'"`’]/g, " ")
    .replace(/[\\/_.,;:+-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

const HEX_BY_VALUE = new Map(
  Object.entries(RAW_HEX_BY_VALUE).map(([key, hex]) => [normalizeColorKey(key), hex])
);

const COLOR_FAMILY_RULES = [
  { tokens: ["chorn", "chervon"], hex: "#472126" },
  { tokens: ["prozor"], hex: "#e8eef5" },
  { tokens: ["transparent"], hex: "#e8eef5" },
  { tokens: ["zolot"], hex: "#d4af37" },
  { tokens: ["gold"], hex: "#d4af37" },
  { tokens: ["sribl"], hex: "#c4c9ce" },
  { tokens: ["silver"], hex: "#c4c9ce" },
  { tokens: ["chorn", "pyton"], hex: "#2f2f34" },
  { tokens: ["rozhev", "pyton"], hex: "#d88ea6" },
  { tokens: ["shokolad", "pyton"], hex: "#6a4a3c" },
  { tokens: ["burhund", "pyton"], hex: "#7b2d3a" },
  { tokens: ["shokolad"], hex: "#5d4037" },
  { tokens: ["mokko"], hex: "#8d6e63" },
  { tokens: ["karamel"], hex: "#c68a4b" },
  { tokens: ["korychnev"], hex: "#6d4c41" },
  { tokens: ["pisochn"], hex: "#d8be8a" },
  { tokens: ["bezhev"], hex: "#d4c4b0" },
  { tokens: ["persyk"], hex: "#ffccac" },
  { tokens: ["molochn"], hex: "#f4efe6" },
  { tokens: ["bily"], hex: "#ffffff" },
  { tokens: ["white"], hex: "#ffffff" },
  { tokens: ["chorn"], hex: "#1a1a1a" },
  { tokens: ["black"], hex: "#1a1a1a" },
  { tokens: ["rozhev"], hex: "#ff99d6" },
  { tokens: ["malyn"], hex: "#d81b60" },
  { tokens: ["chervon"], hex: "#e53935" },
  { tokens: ["red"], hex: "#e53935" },
  { tokens: ["bordo"], hex: "#7b2230" },
  { tokens: ["bordov"], hex: "#7a1f2b" },
  { tokens: ["burhund"], hex: "#7a263a" },
  { tokens: ["marsala"], hex: "#8e445a" },
  { tokens: ["vyshnev"], hex: "#a5273f" },
  { tokens: ["sir"], hex: "#9e9e9e" },
  { tokens: ["grey"], hex: "#9e9e9e" },
  { tokens: ["gray"], hex: "#9e9e9e" },
  { tokens: ["blakytn"], hex: "#42a5f5" },
  { tokens: ["holub"], hex: "#64b5f6" },
  { tokens: ["syn"], hex: "#1565c0" },
  { tokens: ["elektryk"], hex: "#2962ff" },
  { tokens: ["zelen"], hex: "#2e7d32" },
  { tokens: ["smarahd"], hex: "#0f8b6f" },
  { tokens: ["byryuz"], hex: "#33b8b0" },
  { tokens: ["lilov"], hex: "#b39ddb" },
  { tokens: ["lymon"], hex: "#f6e65b" },
  { tokens: ["zhovt"], hex: "#fbc02d" },
  { tokens: ["orange"], hex: "#fb8c00" },
  { tokens: ["oranzh"], hex: "#fb8c00" },
  { tokens: ["zmiya"], hex: "#8a816f" },
];

export function colorPresetValueToHex(value) {
  if (value == null) return null;
  const key = normalizeColorKey(value);
  if (!key) return null;
  const direct = HEX_BY_VALUE.get(key);
  if (direct) return direct;
  for (const rule of COLOR_FAMILY_RULES) {
    if (rule.tokens.every((token) => key.includes(token))) return rule.hex;
  }
  return null;
}
